import dayjs from 'dayjs';

const dow = {
  // Day of the week mapping
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

function isDay(day, expected) {
  return day === dow[expected];
}

function isWeekend(day) {
  return [dow.sunday, dow.monday].includes(day);
}

class RodTooltipContentGenerator {
  constructor(mode) {
    this.mode = mode || 'daily';
    this.end = null;
    this.start = null;
  }

  perform() {
    this.calculateEnd();
    this.calculateStart();
    return this.generateResult();
  }

  isDiffMonth() {
    return this.start.month() !== this.end.month();
  }

  isDiffYear() {
    return this.start.year() !== this.end.year();
  }

  calculateEnd() {
    const today = dayjs();
    let end = dayjs(today).subtract(1, 'days'); // Previous day
    const endDay = end.day();
    if (isDay(endDay, 'saturday')) {
      end = dayjs(today).day(dow.friday);
    } else if (isWeekend()) {
      end = dayjs(today).day(-2);
    }
    this.end = end;
  }

  calculateStart() {
    let today = this.end;
    if (this.mode === 'anually') {
      today = dayjs(this.end).subtract(1, 'year'); // Previous year
    } else if (this.mode === 'monthly') {
      today = dayjs(this.end).subtract(30, 'days'); // Previous month-ish
    }
    let start = dayjs(today).subtract(1, 'days');
    if (isDay(today.day(), 'monday')) {
      start = dayjs(today).day(-2); // Friday on previous week
    }
    this.start = start;
  }

  getStartString() {
    let format = 'D';
    if (this.isDiffMonth()) {
      format = 'D MMMM';
    }
    if (this.isDiffYear()) {
      format = 'D MMMM YYYY';
    }
    return this.start.format(format);
  }

  getEndString() {
    return this.end.format('D MMMM YYYY');
  }

  generateResult() {
    return `${this.getStartString()} - ${this.getEndString()}`;
  }
}

export default RodTooltipContentGenerator;
